import '../../../common/utils/polyfills.js';
import React from 'react';
import { utils } from 'pro-gallery-lib';
import Gallery from './galleryContainer.js';
import '../../../versionLogger.js';
import { GalleryProvider } from '../../../context/GalleryContext.js';
export default class ProGallery extends React.Component {
    constructor() {
        super();
        if (utils.isLocal() && !utils.isTest()) {
            console.log('PRO GALLERY DEV');
        }
    }
    renderProps() {
        var _a;
        return Object.assign(Object.assign({}, this.props), { id: this.props.id, items: this.props.items || [], settings: this.props.settings || {}, offsetTop: this.props.offsetTop, proGalleryRegionLabel: this.props.proGalleryRegionLabel, isInDisplay: (_a = this.props.isInDisplay) !== null && _a !== void 0 ? _a : true });
    }
    containerProps() {
        return {
            id: `pro-gallery-${this.props.id}`,
            className: 'pro-gallery',
        };
    }
    render() {
        return (React.createElement(GalleryProvider, Object.assign({}, this.props),
            React.createElement("div", Object.assign({}, this.containerProps()),
                React.createElement(Gallery, Object.assign({}, this.renderProps())))));
    }
}
//# sourceMappingURL=proGallery.js.map